import { useState, useEffect } from "react";
import "../styles/AddressPage.css";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import plusicon from "../../../../assets/icons/plusicon.png";
import "react-loading-skeleton/dist/skeleton.css";

import {
  getAddress,
  createAddress,
  deleteAddress,
  editAddress,
  makeDefaultAddress,
} from "../redux/addressSlice";
import { useLocation, useNavigate } from "react-router-dom";
// import logo from "../../assets/icons/Obslogo.png";
import { SquareCheck, X } from "lucide-react";
import { ToastContainer } from "react-toastify";
import toast from 'react-hot-toast';

import Swal from "sweetalert2";
import ProfileBreadcrumbs from "../../../../components/Breadcrumbs/ProfileBreadcrumbs";
import { checkPincode } from "../../../Products/pdp/redux/pincodeSlice";
import Footer from "../../../../components/Footer/Footer";
import API from "../../../../app/api";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";

const AddressPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const savedTab = localStorage.getItem("activeTab");
  const [activeTab, setActiveTab] = useState(savedTab || "profile");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [showEditAddressModal, setShowEditAddressModal] = useState(false);
  const [editAddressData, setEditAddressData] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSession, setOtpSession] = useState(null);
  const [dob, setDob] = useState("");
  const [localLoading, setLocalLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [otpTimer, setOtpTimer] = useState(20);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const { pinset, pinloading, pinerror } = useSelector(
    (state) => state.pincode
  );
  // const activeTab = location.pathname.split("/").pop();
  /* ---------------- TAB STATE (URL SYNC) ---------------- */

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab") || "profile";
    setActiveTab(tab);
  }, [location.search]);

  /* ---------------- BREADCRUMB ---------------- */
  const breadcrumbMap = {
    profile: [{ label: "Profile" }],
    "My orders": [
      { label: "Profile", to: "/profile?tab=profile" },
      { label: "My Orders" },
    ],
    address: [
      { label: "Profile", to: "/profile?tab=profile" },
      { label: "My Addresses" },
    ],
  };
  const breadcrumbPaths = breadcrumbMap[activeTab] || breadcrumbMap.profile;
  const [newAddress, setNewAddress] = useState({
    first_name: "",
    last_name: "",
    mobile: "",
    address: "",
    address2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
  });

  const [editForm, setEditForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    dob: "",
  });
  
  useEffect(() => {
    document.title = "Obsession - Profile";
    localStorage.setItem("activeTab", activeTab);
    navigate(`?tab=${activeTab}`, { replace: true });
  }, [activeTab]);

  // 30-3-2026 Active  changes -------

 useEffect(() => {
  const params = new URLSearchParams(location.search);
  const tabFromUrl = params.get("tab");

  if (tabFromUrl) {
    setActiveTab(tabFromUrl);
  } else {
    // default fallback
    setActiveTab("profile");
    navigate("?tab=profile", { replace: true });
  }
}, [location.search]);

// changes end ------------



  const handleTabChange = (tab) => {
    setActiveTab(tab);
    navigate(`?tab=${tab}`, { replace: true });
    localStorage.setItem("activeTab", tab);
  };

  useEffect(() => {
    if (
      showEditModal ||
      showAddAddressModal ||
      showEditAddressModal ||
      showOtpModal   // added this
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [
    showEditModal,
    showAddAddressModal,
    showEditAddressModal,
    showOtpModal   // added this
  ]);

  const { data: addressdata } = useSelector((state) => state.address);
  useEffect(() => {
    dispatch(getAddress());
  }, [dispatch]);
  useEffect(() => {
    let timer;

    if (showOtpModal && otpTimer > 0) {
      timer = setTimeout(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    }
    if (otpTimer === 0) {
      setCanResendOtp(true);
    }

    return () => clearTimeout(timer);
  }, [showOtpModal, otpTimer]);



  const handleModalClick = (e, closer) => {
    if (e.target.classList.contains("modal-overlay")) {
      closer();
    }
  };



  const validateAddressForm = (form) => {
    let formErrors = {};

    if (!form.first_name.trim()) {
      formErrors.first_name = "First name is required";
    } else if (!/^[A-Za-z\s]+$/.test(form.first_name)) {
      formErrors.first_name = "Only alphabets are allowed";
    } else if (form.first_name.trim().length < 3) {
      formErrors.first_name = "First name must be at least 3 characters long";
    }

    if (!form.last_name.trim()) {
      formErrors.last_name = "Last name is required";
    } else if (!/^[A-Za-z\s]+$/.test(form.last_name)) {
      formErrors.last_name = "Only alphabets are allowed";
    } else if (form.last_name.trim().length < 3) {
      formErrors.last_name = "Last name must be at least 3 characters long";
    }

    if (!form.mobile.trim()) {
      formErrors.mobile = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.mobile)) {
      formErrors.mobile = "Enter a valid 10-digit Indian number";
    }

    if (!form.address.trim()) {
      formErrors.address = "Address is required";
    } else if (form.address.trim().length < 5) {
      formErrors.address = "Address 1 must be at least 5 characters long";
    }

    if (!form.city.trim()) {
      formErrors.city = "City is required";
    } else if (!/^[A-Za-z\s]+$/.test(form.city)) {
      formErrors.city = "City must contain only letters";
    }

    if (!form.state.trim()) {
      formErrors.state = "State is required";
    } else if (!/^[A-Za-z\s]+$/.test(form.state)) {
      formErrors.state = "State must contain only letters";
    }

    if (!form.pincode.trim()) {
      formErrors.pincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(form.pincode)) {
      formErrors.pincode = "Enter a valid 6-digit pincode";
    }
    if (!form.address2.trim()) {
      formErrors.address2 = "Address 2 is required";
    } else if (form.address2.trim().length < 5) {
      formErrors.address2 = "Address 2 must be at least 5 characters long";
    }

    if (!form.landmark.trim()) {
      formErrors.landmark = "landmark is required";
    } else if (form.landmark.trim().length < 5) {
      formErrors.landmark = "Landmark must be at least 5 characters long";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; //  valid if no errors
  };

  useEffect(() => {
    if (pinset?.city && pinset?.state && newAddress.pincode.length === 6) {
      setNewAddress((prev) => ({
        ...prev,
        city: pinset.city,
        state: pinset.state,
      }));
    }
  }, [pinset]);

  const handleNewAddressChange = (e) => {
    const { name, value } = e.target;

    setNewAddress((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "pincode" && value.length < 6
        ? { city: "", state: "" } //  auto clear
        : {}),
    }));

    if (name === "pincode" && value.length === 6) {
      dispatch(checkPincode(value));
    }
  };

  // Address chnage
  const handleEditAddressChange = (e) => {
    const { name, value } = e.target;
    setEditAddressData((prev) => ({ ...prev, [name]: value }));
    if (name === "pincode" && value.length === 6) {
      dispatch(checkPincode(value));
    }
  };
  const deteteAddress = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to remove this address!",
      // icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      buttonsStyling: false, // IMPORTANT
      customClass: {
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteAddress(id));

        Swal.fire({
          title: "Deleted!",
          text: "Address has been removed.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const mkdaddress = (id) => {
    dispatch(makeDefaultAddress(id));
    dispatch(getAddress());
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        limit={1}
        toastStyle={{
          padding: "14px",
          color: "#000",
          fontSize: "14px",
          borderRadius: "8px",
        }}
      />

   <Breadcrumbs
      paths={[
        {
          label: 'My Account',
          to: "/accounts/profile",
        }, {
          label: 'Addresses',
          to: "",
        },
      ]}
    />

      <div className="profile-container" style={{ paddingTop:"20px"}}>
 
        <div className="content-wrapper">
                    <div className="address-section">
              <div
                className="address-card add"
                onClick={() => setShowAddAddressModal(true)}
              >
                <div>
                  <div className="addaddressicon">
                    <img src={plusicon} alt="plus" />
                  </div>
                  <div>Add Address</div>
                </div>
              </div>
              {addressdata.map((item, index) => (
                <div className="address-list" key={index + 1}>
                  <div className={`address-card ${item.is_default ? "default" : ""
                    }`}
                  >
                    <div className="address-header">
                      <span className="txt_head_add">
                        {/* {item.is_default ? "HOME (Default)" : "Address"} */}
                        {item.first_name} {item.last_name}
                      </span>
                      {item.is_default && (
                        <span className="green-tick">
                          <SquareCheck />
                        </span>
                      )}
                    </div>
                    <p className="address_title_text">
                      {item.address},{item.landmark},{item.city}, {item.state},
                      {item.pincode}
                    </p>
                    <div className="card-actions">
                      <span
                        onClick={() => {
                          setEditAddressData(item);
                          setShowEditAddressModal(true);
                        }}
                      >
                        Edit
                      </span>
                      <span onClick={() => deteteAddress(item.id)}>Remove</span>
                      {item?.is_default === true ? (
                        <span> </span>
                      ) : (
                        <span onClick={() => mkdaddress(item.id)}>
                          Make Default
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
        </div>

        {/* Edit Profile Modal */}

        {showAddAddressModal && (
          <div
            className="modal-overlay"
            onClick={(e) =>
              handleModalClick(e, () => setShowAddAddressModal(false))
            }
          >
            <div className="side-modal">
              <div className="head-modal">
                <button className="close-btn"
                  onClick={() => {
                    setShowAddAddressModal(false);
                    setErrors({});
                  }}
                >
                  <IoMdClose />
                </button>
                <h3>Add New Address</h3>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!validateAddressForm(newAddress)) return; // stop if validation fails
                  dispatch(createAddress(newAddress)).then((res) => {
                    if (res.meta.requestStatus === "fulfilled") {
                      dispatch(getAddress());
                      setNewAddress({
                        first_name: "",
                        last_name: "",
                        mobile: "",
                        address: "",
                        address2: "",
                        landmark: "",
                        city: "",
                        state: "",
                        pincode: "",
                      });
                      setShowAddAddressModal(false);
                      setErrors({}); // clear errors on success
                      toast.success("Address Added Successfully.");
                    }
                  });
                }}
              >
                <label>
                  <span>
                    First Name <span className="required">*</span>
                  </span>
                  <input
                    name="first_name"
                    value={newAddress.first_name}
                    onChange={handleNewAddressChange}
                  />
                  {errors.first_name && (
                    <p className="error">{errors.first_name}</p>
                  )}
                </label>

                <label>
                  <span>
                    Last Name <span className="required">*</span>
                  </span>
                  <input
                    name="last_name"
                    value={newAddress.last_name}
                    onChange={handleNewAddressChange}
                  />
                  {errors.last_name && (
                    <p className="error">{errors.last_name}</p>
                  )}
                </label>
                <label>
                  <span>
                    Mobile Number <span className="required">*</span>
                  </span>
                  <input
                    name="mobile"
                    maxLength={10}
                    value={newAddress.mobile}
                    onChange={handleNewAddressChange}
                  />
                  {errors.mobile && <p className="error">{errors.mobile}</p>}
                </label>
                <label>
                  <span>
                    Pincode <span className="required">*</span>
                  </span>
                  <input
                    name="pincode"
                    value={newAddress.pincode}
                    onChange={handleNewAddressChange}
                  />
                  {errors.pincode && <p className="error">{errors.pincode}</p>}
                </label>
                <label>
                  <span>
                    State <span className="required">*</span>
                  </span>
                  <input
                    name="state"
                    value={newAddress.state ?? ''}
                  />
                  {errors.state && <p className="error">{errors.state}</p>}
                </label>
                <label>
                  <span>
                    City <span className="required">*</span>
                  </span>
                  <input
                    name="city"
                    value={newAddress.city ?? ''}
                  />
                  {errors.city && <p className="error">{errors.city}</p>}
                </label>
                <label>
                  <span>
                    Street Address 1 <span className="required">*</span>
                  </span>
                  <input
                    name="address"
                    value={newAddress.address}
                    onChange={handleNewAddressChange}
                  />
                  {errors.address && <p className="error">{errors.address}</p>}
                </label>
                <label>
                  <span>
                    Street Address 2 <span className="required">*</span>
                  </span>
                  <input
                    name="address2"
                    value={newAddress.address2}
                    onChange={handleNewAddressChange}
                  />
                  {errors.address2 && (
                    <p className="error">{errors.address2}</p>
                  )}
                </label>
                <label>
                  <span>
                    Landmark <span className="required">*</span>
                  </span>
                  <input
                    name="landmark"
                    value={newAddress.landmark}
                    onChange={handleNewAddressChange}
                  />
                  {errors.landmark && (
                    <p className="error">{errors.landmark}</p>
                  )}
                </label>
                <button type="submit">Add Address</button>
              </form>
            </div>
          </div>
        )}
        
        {showEditAddressModal && (
          <div className="modal-overlay">
            <div className="side-modal" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-btn"
                onClick={() => {
                  setShowEditAddressModal(false);
                  setErrors({});
                }}
               >
              <IoMdClose size={25} />
              </button>
              <h3> Edit Address </h3>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!validateAddressForm(editAddressData)) return; // stop if validation fails
                  dispatch(
                    editAddress({
                      id: editAddressData.id,
                      data: editAddressData,
                    })
                  ).then((res) => {
                    if (res.meta.requestStatus === "fulfilled") {
                      dispatch(getAddress());
                      setShowEditAddressModal(false);
                      setEditAddressData(null);
                      setErrors({});
                      toast.success("Address Updated Successfully.");
                    }
                  });
                }}
              >
                <label>
                  <span>
                    First Name <span className="required">*</span>
                  </span>
                  <input
                    name="first_name"
                    value={editAddressData?.first_name || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.first_name && (
                    <p className="error">{errors.first_name}</p>
                  )}
                </label>
                <label>
                  <span>
                    Last Name <span className="required">*</span>
                  </span>
                  <input
                    name="last_name"
                    value={editAddressData?.last_name || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.last_name && (
                    <p className="error">{errors.last_name}</p>
                  )}
                </label>
                <label>
                  <span>
                    Mobile Number <span className="required">*</span>
                  </span>
                  <input
                    name="mobile"
                    maxLength={10}
                    value={editAddressData?.mobile || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.mobile && <p className="error">{errors.mobile}</p>}
                </label>
                <label>
                  <span>
                    PIN Codexxx <span className="required">*</span>
                  </span>
                  <input
                    name="pincode"
                    value={editAddressData?.pincode || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.pincode && <p className="error">{errors.pincode}</p>}
                </label>
                <label>
                  <span>
                    State <span className="required">*</span>
                  </span>
                  <input
                    name="state"
                    value={editAddressData?.state || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.state && <p className="error">{errors.state}</p>}
                </label>
                <label>
                  <span>
                    City <span className="required">*</span>
                  </span>
                  <input
                    name="city"
                    value={editAddressData?.city || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.city && <p className="error">{errors.city}</p>}
                </label>
                <label>
                  <span>
                    Street Address 1 <span className="required">*</span>
                  </span>
                  <input
                    name="address"
                    value={editAddressData?.address || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.address && <p className="error">{errors.address}</p>}
                </label>
                <label>
                  <span>
                    Street Address 2 <span className="required">*</span>
                  </span>
                  <input
                    name="address2"
                    value={editAddressData?.address2 || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.address2 && (
                    <p className="error">{errors.address2}</p>
                  )}
                </label>
                <label>
                  <span>
                    Landmark <span className="required">*</span>
                  </span>
                  <input
                    name="landmark"
                    value={editAddressData?.landmark || ""}
                    onChange={handleEditAddressChange}
                  />
                  {errors.landmark && (
                    <p className="error">{errors.landmark}</p>
                  )}
                </label>
                <button type="submit">Update Address</button>
              </form>
            </div>
          </div>
        )}
        </div>
      <Footer />
    </>
  );
};
export default AddressPage;
